import {
  FETCH_SALES_COMPETENCY_REVIEW_ITEMS,
} from '../actions/types';

const DEFAULT_STATE = {
  loading: true,
  error: null,
  data: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case FETCH_SALES_COMPETENCY_REVIEW_ITEMS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        items: action.payload.items,
        version: action.payload.versionLabel,
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/salesCompetencyReviewItemsReducer.js